import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22index.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../fonts/PPEditorialNew-Ultralight.woff2%22,%22weight%22:%22200%22,%22style%22:%22normal%22},{%22path%22:%22../../fonts/PPEditorialNew-UltralightItalic.woff2%22,%22weight%22:%22200%22,%22style%22:%22italic%22}],%22variable%22:%22--font-serif%22}],%22variableName%22:%22EditorialNew%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'EditorialNew', 'EditorialNew Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
